export default __webpack_public_path__ + "static/media/unit-execution-notification-1.9f98aaa8.mp3";